import api from "../axios";
import { invalidateDisciplinesCache } from "./disciplines";

/**
 * Get next suggested chapter number
 * @param {number} categoryId - Category ID
 * @param {number|null} parentChapterId - Optional parent chapter ID
 */
export const getNextChapterNumber = async (categoryId, parentChapterId = null) => {
  const params = parentChapterId ? `?parent_chapter_id=${parentChapterId}` : '';
  const response = await api.get(`/categories/${categoryId}/chapters/next_number${params}`);
  return response.data;
};

/**
 * Create a new chapter
 * @param {number} categoryId - Category ID
 * @param {Object} chapterData - Chapter data (number, title, description, parent_chapter_id)
 */
export const createChapter = async (categoryId, chapterData) => {
  const response = await api.post(`/categories/${categoryId}/chapters`, {
    chapter: chapterData
  });
  invalidateDisciplinesCache();
  return response.data;
};

/**
 * Update a chapter
 * @param {number} categoryId - Category ID
 * @param {number} chapterId - Chapter ID
 * @param {Object} chapterData - Chapter data
 */
export const updateChapter = async (categoryId, chapterId, chapterData) => {
  const response = await api.patch(`/categories/${categoryId}/chapters/${chapterId}`, {
    chapter: chapterData
  });
  invalidateDisciplinesCache();
  return response.data;
};

/**
 * Delete a chapter
 * @param {number} categoryId - Category ID
 * @param {number} chapterId - Chapter ID
 */
export const deleteChapter = async (categoryId, chapterId) => {
  const response = await api.delete(`/categories/${categoryId}/chapters/${chapterId}`);
  invalidateDisciplinesCache();
  return response.data;
};

